<template>
  <div>

    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="런치팩 고객 1:1문의"
      desc="런치팩에게 1:1문의한 목록을 볼수있습니다.">

      <!-- 문의 카테고리 -->
      <div slot="inquiry_category">
        <span class="select">
          <select @change="selectCategory">
            <option value="">전체</option>
            <option v-for="(cat, idx) in cats"
                    :key="'cat'+idx"
                    :value="cat.value">{{ cat.label }}</option>
          </select>
        </span>
      </div>
    </admin-filter>

    <div class="btn-group-justify-end">
      <button @click="$router.push(getPath('launchpack/inquiry/customer/create'))"
              class="button is-primary">1:1문의 등록</button>
    </div>


    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="800"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <div slot="title" slot-scope="props" class="unselect" style="text-decoration:underline">
        <div @click="$router.push(`customer/create?id=${props.item.id}`)">{{ props.item.title }}</div>
      </div>

      <div slot="status" slot-scope="props">
        <div v-if="props.item.status===0">미확인</div>
        <div v-else-if="props.item.status===2">진행중</div>
        <div v-else-if="props.item.status===3">완료</div>
      </div>

      <div slot="comment_status" slot-scope="props" style="width: 120px; margin: auto;">
        <div v-if="props.item.is_answered">답변 완료</div>
        <div v-else>답변 대기</div>
      </div>

      <div slot="is_new" slot-scope="props">
        {{ props.item.is_new? 'O': 'X' }}
      </div>

      <div slot="detail" slot-scope="props">
        <button class="button state-btn btn-make-comment"
                @click.stop.prevent="clickAnswer(props.item.id)">상세 보기</button>
      </div>
    </admin-table>
  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'

  export default {

    mixins: [
      ListMixin  // 목록페이지의 공통적인 데이터 및 함수는 List.js에 다 구성되어 있다.
    ],
    data() {
      return {
        cats: []
      }
    },
    created(){
      this.init();

    },
    methods: {
      init () {
        /* 테이블, 필터를 구성할 structure_path, url을 파라미터로 넘겨준다.
      *  structure.js에 structure_path에 맞게 데이터를 생성한다.
      *  해당 url에 맞게 axios 호출이 잘되는지 확인한다.
      * */
        this.initializing('customer_inquiry', 'launchpack/inquiry/customer');
        this.getCategory();
      },
      getDataFromServer() {
        this.getData();
      },
      getCategory() {
        this.$axios.get(this.masterBackendUrl + 'public/launchpack/inquiry/customer/category').then(res=>{
          this.cats = res.data;
        })
      },
      // 문의 카테고리 선택
      selectCategory(e) {
        this.filtered.category = e.target.value;
        this.getData();
      },
      // 답변 달기
      clickAnswer(id){
        this.$router.push(this.getPath('launchpack/inquiry/customer/create?id='+id));
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>

  @import '~assets/css/lp_main';

  .tr-whole-border th
    padding 12px 6px

  .many-field-tr td
    padding 6px

  .progress-btn
    border-radius 3px
    display inline-block
    width 84px
    padding 6px 0
    margin 2px
    font-weight bold
    font-size .8rem

  .bid-state
    margin 2px 0
    color #fff
    border-radius 3px
    display inline-block
    width 76px
    padding 4px

  .btn-request-sheet
    color white
    background-color #5cb85c

  .bid-state-done
    background-color #5cb85c
  .bid-state-ing
    background-color #1c7cd5
  .bid-state-ok
    background-color #5cb85c
  .bid-state-no
    background-color #f0ad4e

  .q-title
    font-size 0.9rem
    color $primary
    margin-top 20px
    margin-bottom 4px

  .est-title
    padding 20px
    font-size 1.2rem
    border-bottom 1px solid $primary

  .est-table
    padding 20px
    max-height 80vh

  .est-table table
    width 100%

  .est-table table
  .est-table th
  .est-table td
    border 0
    padding 4px 0
    text-align center

  .modal-title
    margin 20px 0 8px 0
    color #064160
    font-size 0.9rem
    font-weight bold

  .modal-desc
    padding 20px
    background-color #eee

  .td-est:hover
    background-color #eeeeee
    cursor pointer

  .lp-btn-bid
    cursor pointer
    border-radius 3px
    color white
    padding 4px 6px
    font-size 0.8rem
    width 74px
    margin auto
    margin-top 4px
    background-color $primary

  .btn-add
    width 24px
    height 24px
    line-height 23px
    text-align center
    font-size 1rem
    color white
    background-color $primary
    border-radius 50%

  .lp-custom-modal-btns
    padding 20px

  .btn-close
    width 45px
    color #777
    text-align center
    margin auto 0
</style>
